import { Button, FieldMessage, useToggle } from '@oforce/global-components';
import React, { useState } from 'react';
import { BoxContainer, TabPage } from '../../../../components';
import { useImportExposures, useImportFormOptions, useRowValidation, useValidation } from './hooks';
import UploadExposureImportFileModal from './UploadExposureImportFileModal';
import { ImportSummary } from '../../../../components/csvValidation';

export default function ImportExposures({ policy }) {
  const [parsedRows, setParsedRows] = useState([]);
  const [reviewingRows, setReviewingRows] = useState(false);
  const [uploadModalIsOpen, toggleUploadModal] = useToggle(false);

  const { formOptions } = useImportFormOptions({ policy });

  const { onSubmit, loading: submitLoading, error, jobId } = useImportExposures({ policy });
  const submitAttrs = { loading: submitLoading, error, jobId };

  return (
    <>
      {!reviewingRows && (
        <TabPage centered size="lg" title={'Import Exposures'} showBackButton>
          <BoxContainer className="p-4 p-md-5 mb-3">
            <h3 style={{ letterSpacing: '-1px' }}>Choose a file to begin the awesome import process!</h3>
            <div className="mb-5">
              Once you choose a file, we will parse it and give you the ability to edit fields before importing your
              exposures.
            </div>
            <FieldMessage icon={['far', 'info-circle']}>
              Start dates will reflect the policy's effective date or the passed in start date from your file, whichever
              is later.
            </FieldMessage>

            <FieldMessage icon={['far', 'info-circle']}>
              Termination dates will reflect the policy's expiration date or the passed in termination date from your
              file, whichever is earlier.
            </FieldMessage>

            <div className="d-flex mt-3">
              <Button color="success" onClick={toggleUploadModal}>
                Choose Csv File
              </Button>
            </div>
          </BoxContainer>
        </TabPage>
      )}

      {reviewingRows && (
        <ImportSummary
          policy={policy}
          submitAttrs={submitAttrs}
          useRowValidation={useRowValidation}
          useValidation={useValidation}
          formOptions={formOptions}
          rows={parsedRows}
          onComplete={onSubmit}
          onBack={() => setReviewingRows(false)}
        />
      )}

      {uploadModalIsOpen && (
        <UploadExposureImportFileModal
          policy={policy}
          formOptions={formOptions}
          isOpen={uploadModalIsOpen}
          toggle={toggleUploadModal}
          onParseComplete={data => {
            setParsedRows(data);
            setReviewingRows(true);
            toggleUploadModal();
          }}
        />
      )}
    </>
  );
}
